import { UnenrollmentReasonOption } from '../../unenroll-reason/constants'

export type CMSUnenrollmentDeviceType =
  | 'vehicle'
  | 'vehicleCharger'
  | 'thermostat'
  | 'battery'
  | 'program'

export const DEFAULT_ARTICLE_SUGGESTIONS: {
  device: CMSUnenrollmentDeviceType
  reasons: UnenrollmentReasonOption['value'][]
  articleUrl: string
  articleText: string
}[] = [
  // EV - Not charging to limit
  {
    device: 'vehicle',
    reasons: ['not_charging_to_limit'],
    articleUrl:
      'https://optiwatt.zendesk.com/hc/en-us/articles/35601455365659-What-managed-charging-features-do-you-offer#h_01JRBC83PTGBYCVCY42HDQJ0CX',
    articleText: 'What managed charging features do you offer?',
  },
  // EV - Charging during peak times
  {
    device: 'vehicle',
    reasons: ['charging_during_peak_times'],
    articleUrl:
      'https://optiwatt.zendesk.com/hc/en-us/articles/35601426867739-How-does-Optiwatt-decide-when-to-start-a-charge#h_01JRKS1DJ9MXN53B252M4XEPQH',
    articleText: 'How does Optiwatt decide when to start a charge?',
  },
  // EV - Overriding existing schedule
  {
    device: 'vehicle',
    reasons: ['overriding_existing_schedule'],
    articleUrl:
      'https://optiwatt.zendesk.com/hc/en-us/articles/41171634864411-Why-is-Optiwatt-overriding-my-charging-schedule',
    articleText: 'Why is Optiwatt overriding my charging schedule?',
  },
  {
    device: 'vehicle',
    reasons: ['overriding_existing_schedule'],
    articleUrl:
      'https://optiwatt.zendesk.com/hc/en-us/articles/35601426867739-How-does-Optiwatt-decide-when-to-start-a-charge#h_01JRKS1DJ9MXN53B252M4XEPQH',
    articleText: 'How does Optiwatt decide when to start a charge?',
  },
  // Smart Thermostat - It's too hot/too cold
  {
    device: 'thermostat',
    reasons: ['too_hot_cold'],
    articleUrl:
      'https://optiwatt.zendesk.com/hc/en-us/articles/39309598427419-How-do-I-manage-my-thermostat-using-Save-Money',
    articleText: 'How do I manage my thermostat using Save Money?',
  },
  // Smart Thermostat - Unexpected adjustments
  {
    device: 'thermostat',
    reasons: ['unexpected_adjustments'],
    articleUrl:
      'https://optiwatt.zendesk.com/hc/en-us/articles/41017692178331-How-does-Optiwatt-s-Precool-feature-work',
    articleText: "How does Optiwatt's Precool feature work?",
  },
  // EVSE - Not charging to limit
  {
    device: 'vehicleCharger',
    reasons: ['not_charging_to_limit'],
    articleUrl:
      'https://optiwatt.zendesk.com/hc/en-us/articles/35601455365659-What-managed-charging-features-do-you-offer#h_01JRBC83PTGBYCVCY42HDQJ0CX',
    articleText: 'What managed charging features do you offer?',
  },
  // EVSE - Charging during peak times
  {
    device: 'vehicleCharger',
    reasons: ['charging_during_peak_times'],
    articleUrl:
      'https://optiwatt.zendesk.com/hc/en-us/articles/35601426867739-How-does-Optiwatt-decide-when-to-start-a-charge#h_01JRKS1DJ9MXN53B252M4XEPQH',
    articleText: 'How does Optiwatt decide when to start a charge?',
  },
  // EVSE - Overriding existing schedule
  {
    device: 'vehicleCharger',
    reasons: ['overriding_existing_schedule'],
    articleUrl:
      'https://optiwatt.zendesk.com/hc/en-us/articles/41171634864411-Why-is-Optiwatt-overriding-my-charging-schedule',
    articleText: 'Why is Optiwatt overriding my charging schedule?',
  },
  {
    device: 'vehicleCharger',
    reasons: ['overriding_existing_schedule'],
    articleUrl:
      'https://optiwatt.zendesk.com/hc/en-us/articles/35601426867739-How-does-Optiwatt-decide-when-to-start-a-charge#h_01JRKS1DJ9MXN53B252M4XEPQH',
    articleText: 'How does Optiwatt decide when to start a charge?',
  },
  // Battery - Exporting to grid during peak times
  {
    device: 'battery',
    reasons: ['exporting_to_grid_during_peak_times'],
    articleUrl:
      'https://optiwatt.zendesk.com/hc/en-us/articles/40178648687387-What-should-I-expect-during-Demand-Response-events',
    articleText: 'What should I expect during Demand Response events?',
  },
  // Battery - Overriding existing schedule
  {
    device: 'battery',
    reasons: ['overriding_existing_schedule'],
    articleUrl:
      'https://optiwatt.zendesk.com/hc/en-us/articles/40178648687387-What-should-I-expect-during-Demand-Response-events',
    articleText: 'What should I expect during Demand Response events?',
  },
  // Program - Program wasn't clear or valuable to me
  {
    device: 'program',
    reasons: ['program_not_clear_or_valuable'],
    articleUrl:
      'https://optiwatt.zendesk.com/hc/en-us/categories/35556339818267-Utility-Programs',
    articleText:
      'What are the benefits of participating in the Optiwatt program?',
  },
  // Program - Security/privacy concerns
  {
    device: 'program',
    reasons: ['security_privacy_concerns'],
    articleUrl: 'https://optiwatt.com/privacy',
    articleText: "What is Optiwatt's privacy policy?",
  },
]

export const DEFAULT_SETTTING_SUGGESTIONS: {
  device: CMSUnenrollmentDeviceType
  reason: UnenrollmentReasonOption['value']
  setting: string
}[] = [
  {
    device: 'vehicle',
    reason: 'not_charging_to_limit',
    setting: 'charge-schedule',
  },
  {
    device: 'vehicle',
    reason: 'not_charging_to_limit',
    setting: 'charge-limits',
  },
  {
    device: 'vehicle',
    reason: 'charging_during_peak_times',
    setting: 'charge-goals',
  },
  {
    device: 'thermostat',
    reason: 'too_hot_cold',
    setting: 'save-money',
  },
  {
    device: 'thermostat',
    reason: 'too_hot_cold',
    setting: 'grid-support',
  },
  {
    device: 'thermostat',
    reason: 'temperature_adjustments_too_frequent',
    setting: 'save-money',
  },
  {
    device: 'thermostat',
    reason: 'unexpected_adjustments',
    setting: 'save-money',
  },
  {
    device: 'thermostat',
    reason: 'unexpected_adjustments',
    setting: 'precool',
  },
  {
    device: 'vehicleCharger',
    reason: 'not_charging_to_limit',
    setting: 'charge-schedule',
  },
  {
    device: 'vehicleCharger',
    reason: 'not_charging_to_limit',
    setting: 'charge-limits',
  },
  {
    device: 'vehicleCharger',
    reason: 'charging_during_peak_times',
    setting: 'charge-goals',
  },
]
